import i18n from "../i18n";
import { IInboxSyncResult } from "../models/messagesInbox/IInboxApi";
import { DefaultResponseWithData } from "../models/system";

const tr = (key: string, options?: Record<string, unknown>) => i18n.t(key, { ns: "messages", ...options });

export type SyncNoticeTone = "amber" | "red";

/**
 * What to tell the person after Refresh ran the sync. Nothing when it ran cleanly (the list
 * reloading says it all); amber when it was skipped ("synced a moment ago") or a channel had a
 * problem; red when the API refused.
 */
export function syncNotice(res: DefaultResponseWithData<IInboxSyncResult | null> | undefined): { tone: SyncNoticeTone; text: string } | undefined {
  if (!res) return undefined;
  if (!res.success) return { tone: "red", text: res.message || tr("Couldn't check for new messages – showing the last ones loaded.") };
  const result = res.data;
  if (!result) return undefined;
  if (!result.ran) return { tone: "amber", text: result.skipped || res.message || tr("Messages were checked a moment ago.") };
  if (result.problems.length > 0) return { tone: "amber", text: result.problems.join(". ") };
  return undefined;
}

/** The text under the spinner while the list loads: a database read now, so it's quick. */
export function listLoadingText() {
  return tr("Loading messages…");
}
